export default __webpack_public_path__ + "static/Inbox-1@2x-535dcccb5dcdd5cc1d3962d063238133.svg";